export const MIN_RATING = 400;
export const MAX_RATING = 3000;

export function getK(attempts) {
  if (attempts < 5) return 256;
  if (attempts < 15) return 64;
  if (attempts < 25) return 32;
  return 20;
}

export function clampDelta(delta, attempts) {
  if (attempts < 20) return Math.max(-120, Math.min(120, delta));
  if (attempts < 50) return Math.max(-40, Math.min(40, delta));
  return Math.max(-20, Math.min(20, delta));
}

export function getRangeDelta(attempts) {
  if (attempts < 10) return 200;
  if (attempts < 20) return 150;
  return 100;
}

export function updateRating(currentRating, puzzleRating, correct, attempts) {
  const expected = 1 / (1 + Math.pow(10, (puzzleRating - currentRating) / 400));
  const actual = correct ? 1 : 0;
  const delta = clampDelta(getK(attempts) * (actual - expected), attempts);

  return Math.round(
    Math.max(MIN_RATING, Math.min(MAX_RATING, currentRating + delta))
  );
}
